import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'ethiopia_provide_time_off_workers_appear_labor_dispute'

export const dataPointDefinition = {
  retracedId: 'ethiopia_provide_time_off_workers_appear_labor_dispute',
  name: 'Ethiopia: Provide time off for workers to appear at labor dispute hearings and to exercise their civil rights and duties',
  description:
    'This question is specific to Ethiopia only. Please consult the Law Overlay for more information on applicable legal requirements. ',
  meta: {
    slcpMeta: {
      key: 'wb-wag-123x',
      number: 'WH-WOR-25-9',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-wag-123x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35540,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
